import styled, { css } from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexRow } from "@similarweb/ui-components";

import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

import { SingleWebsiteInput } from "../../Shared/SingleWebsiteInput/SingleWebsiteInput";

const { carbon, bluegrey } = colorsPalettes;

export const Wrapper = styled(FlexColumn)`
    margin-bottom: 16px;
    position: relative;
`;

export const SuggestedItemsListWrapper = styled(FlexColumn)`
    flex-grow: 1;
    width: 100%;
    align-items: center;
`;

export const LoaderWrapper = styled(FlexColumn)`
    justify-content: center;
    margin-top: 20px;
    margin-bottom: 32px;

    @media (max-height: 800px) {
        margin-top: 0;
        margin-bottom: 4px;
    }
`;

export const SelectedDomainTitle = styled.div`
    ${setFontVariant("h5", carbon[500])}
    margin-bottom: 36px;
`;

export const SelectCountryTitle = styled.p`
    ${setFontVariant("body1", carbon[400])}
    margin: 0 0 16px;
`;

export const WrappedSelectGroup = styled(FlexRow)`
    gap: 24px;
`;

export const WrappedSelect = styled(FlexColumn)`
    width: 50%;
    z-index: 100;
`;

const CompetitorsWrapper = styled(FlexRow)`
    justify-content: space-between;
`;

export const CompetitorsLimitText = styled(FlexRow)`
    ${setFontVariant("body1", carbon[400])};
    align-items: center;
    gap: 8px;
`;

export const CompetitorsLimit = styled.span`
    ${setFontVariant("chip1", carbon[300])}
`;

export const CompetitorsDropdownWrapper = styled(FlexRow)`
    justify-content: space-between;
    position: relative;
    align-items: center;
    padding: 16px 0;
`;

export const StyledWebsiteInput = styled(SingleWebsiteInput)<{ isDisabled: boolean }>`
    ${({ isDisabled }) =>
        isDisabled &&
        css`
            background-color: ${carbon[0]};
            border: 1px solid ${carbon[50]};
            opacity: 0.6;

            .ListItemWebsite {
                background-color: ${carbon[0]};
            }
        `}
`;

export const AIInputWrapper = styled(FlexColumn)`
    gap: 12px;
    padding: 20px 32px 0;
    margin: 0 -32px;
    border-top: 1px solid ${carbon[50]};
    background: linear-gradient(180deg, ${bluegrey[100]} 0%, ${carbon[0]} 100%);
`;
